import { decode, encode } from 'html-entities';

const ENTITY = /&(?:[a-zA-Z][a-zA-Z0-9]*|#\d+|#[xX][0-9a-fA-F]+);/g;
const LESS_THAN_ENTITY = /^&(?:lt|#0*60|#[xX]0*3[cC]);$/;

/**
 * Encodes XML special characters to their entity equivalents to prevent XSS attacks.
 */
export function encodeXMLEntities(str: string): string {
  return encode(str, { mode: 'specialChars', level: 'xml' });
}

const decodeTextEntities = (text: string): string =>
  text.replace(ENTITY, (entity: string) => (LESS_THAN_ENTITY.test(entity) ? entity : decode(entity)));

/**
 * Decodes the HTML entities of the text of a **sanitized** markup string, leaving its tags untouched
 * and keeping an encoded `<` encoded so that it cannot re-form markup. Use it for renderers that
 * insert markup without decoding the entities in its text, so that encoded values (e.g.
 * `T&amp;O1225`) display as written while encoded tags (`&lt;img src=x&gt;`) stay inert.
 */
export function decodeNonMarkupEntities(markup: string): string {
  return markup.replace(/<[^>]*>|[^<]+/g, (part: string) => (part.startsWith('<') ? part : decodeTextEntities(part)));
}

/**
 * Validates that a URI is a data URI (base64-encoded image).
 * Only data URIs are allowed for security reasons (prevents e.g. 'javascript:' and 'http:' URLs).
 */
export function validateDataURI(uri: string): string {
  if (uri === '') {
    return uri;
  }
  if (!uri.startsWith('data:')) {
    console.error('Only data URIs are allowed for images');
    return '';
  }
  return uri;
}
